import React, { Component } from 'react';
import { kebabCase } from 'lodash';
import { Section, Paragraph, Link, Image } from 'components';
import Logo from 'assets/images/logo-footer.svg';
import { PATHS } from 'config';
import './Footer.scss';
import config from '../../../meta/config';
import IconSVG from '../IconSVG';

class Footer extends Component {
  renderColumn(paths) {
    const items = paths;
    this.filteredPaths = PATHS.filter(item => items.includes(item.name));
    return this.renderNavItems();
  }

  renderNavItems = () =>
    this.filteredPaths.map(item => {
      const { link, name, children } = item;

      const renderChildren = () =>
        children.map(child => (
          <Link
            to={child.link}
            id={`footer-nav-${kebabCase(child.name.toLowerCase())}`}
            key={child.name}
          >
            <Paragraph
              size={'default'}
              color={'white'}
              additionalClass={'services-item'}
            >
              {child.name}
            </Paragraph>
          </Link>
        ));

      return (
        <div key={item.name} className={'footer__menu-item'}>
          {children ? (
            <div className={'footer__menu-services'}>
              <Link
                id={`footer-nav-${kebabCase(name.toLowerCase())}`}
                to={link}
                key={`nav-item-${name}`}
              >
                <span className={'text--white'}>{name}</span>
              </Link>
              {renderChildren()}
            </div>
          ) : (
            <Link
              id={`footer-nav-${kebabCase(name.toLowerCase())}`}
              to={link}
              key={`nav-item-${name}`}
            >
              {name === 'Privacy Policy' ? (
                <span
                  className={
                    'text--white text--default footer__privacy-policy'
                  }
                >
                  {name}
                </span>
              ) : (
                <span className={'text--white'}>{name}</span>
              )}
            </Link>
          )}
        </div>
      );
    });

  render = () => (
    <Section color={'mine-shaft'} additionalClass={'section--footer'}>
      <footer id={'footer'} className={'footer'}>
        <div className={'footer__links'}>
          <nav className={'footer__menu'} aria-label={'main navigation'}>
            {typeof window !== 'undefined' && window.location && (
              <>
                <div className={'footer__menu-column'}>
                  {this.renderColumn(['Work', 'Services'])}
                </div>
                <div className={'footer__menu-column'}>
                  {this.renderColumn(['Approach', 'About', 'Culture'])}
                </div>
                <div className={'footer__menu-column'}>
                  {this.renderColumn([
                    'Contact',
                    'Blog',
                    'Career',
                    'Privacy Policy',
                  ])}
                </div>
              </>
            )}
          </nav>
          <div className={'footer__social-media'}>
            <Link to={config.facebook} id={'footer-facebook'}>
              <IconSVG
                name={'facebook-letter'}
                size={'medium'}
                color={'white'}
              />
            </Link>
            <Link to={config.linkedin} id={'footer-linkedin'}>
              <IconSVG
                name={'linkedin-letter'}
                size={'medium'}
                color={'white'}
              />
            </Link>
            <Link to={config.instagram} id={'footer-instagram'}>
              <IconSVG name={'instagram'} size={'medium'} color={'white'} />
            </Link>
            <Link to={config.twitter} id={'footer-twitter'}>
              <IconSVG name={'twitter'} size={'medium'} color={'white'} />
            </Link>
            <Link to={config.slideshare} id={'footer-slideshare'}>
              <IconSVG name={'slideshare'} size={'medium'} color={'white'} />
            </Link>
          </div>
        </div>
        <div className={'footer__content'}>
          <div className={'footer__description-wrapper'}>
            <Image
              src={Logo}
              additionalClass={'footer__logo'}
              alt={'Boldare logo'}
            />
            <Paragraph
              size={'medium'}
              color={'white'}
              additionalClass={'footer__contact hide-mobile hide-tablet'}
            >
              The digital product design &amp; development <br />
              company. Contact us:
              <Link
                className={'footer__email contact-mail'}
                to={'mailto:hello@boldare.com'}
              >
                <span id={'contact-footer'} className={'text--white'}>
                  {' '}
                  hello@boldare.com{' '}
                </span>
              </Link>
            </Paragraph>
            <Paragraph
              size={'medium'}
              color={'white'}
              additionalClass={'footer__contact hide-desktop'}
            >
              The digital product design &amp;&nbsp;development company.
              <br /> <br />
              Contact us:
              <br />
              <Link
                className={'footer__email contact-mail'}
                to={'mailto:hello@boldare.com'}
              >
                <span id={'contact-footer'} className={'text--white'}>
                  {' '}
                  hello@boldare.com
                </span>
              </Link>
            </Paragraph>
          </div>
          <div className={'footer__places'}>
            <div className={'footer__place'}>
              <Paragraph
                size={'medium'}
                color={'white'}
                additionalClass={'footer__hq text--bold'}
              >
                HQ Gliwice
              </Paragraph>
              <Paragraph color={'white'} additionalClass={'footer__address'}>
                <Link
                  to={
                    'https://www.google.com/maps/search/?api=1&query=Królowej+Bony+13,+41-100+Gliwice'
                  }
                >
                  <span id={'footer-map-gliwice'} className={'text--white'}>
                    ul. Królowej Bony 13
                    <br />
                  </span>
                </Link>
                <span className={'hide-mobile hide-tablet'}>44-100 </span>
                Gliwice, Poland
                <br />
                <Link to={'tel:+48327390900'}>
                  <span id={'footer-phone-gliwice'} className={'text--white'}>
                    {' '}
                    +48 32 739 09 00{' '}
                  </span>
                </Link>
              </Paragraph>
            </div>
            <div className={'footer__place'}>
              <Paragraph
                size={'medium'}
                color={'white'}
                additionalClass={'footer__hq text--bold'}
              >
                Warsaw
              </Paragraph>
              <Paragraph color={'white'} additionalClass={'footer__address'}>
                <Link
                  to={
                    'https://www.google.com/maps/search/?api=1&query=Jasna+24,+00-054+Warszawa'
                  }
                >
                  <span id={'footer-map-warsaw'} className={'text--white'}>
                    ul. Jasna 24
                    <br />
                  </span>
                </Link>
                <span className={'hide-mobile hide-tablet'}>00-054 </span>
                Warsaw, Poland
                <br />
                <Link to={'tel:+48327390900'}>
                  <span id={'footer-phone-warsaw'} className={'text--white'}>
                    {' '}
                    +48 32 739 09 00{' '}
                  </span>
                </Link>
              </Paragraph>
            </div>
            <div className={'footer__place'}>
              <Paragraph
                size={'medium'}
                color={'white'}
                additionalClass={'footer__hq text--bold'}
              >
                Wroclaw
              </Paragraph>
              <Paragraph color={'white'} additionalClass={'footer__address'}>
                <Link
                  to={
                    'https://www.google.com/maps/search/?api=1&query=Hubska+52,+50-502+Wroclaw'
                  }
                >
                  <span id={'footer-map-wroclaw'} className={'text--white'}>
                    ul. Hubska 52/14
                    <br />
                  </span>
                </Link>
                <span className={'hide-mobile hide-tablet'}>50-502 </span>
                Wroclaw, Poland
                <br />
                <Link to={'tel:+48327390900'}>
                  <span id={'footer-phone-wroclaw'} className={'text--white'}>
                    {' '}
                    +48 32 739 09 00{' '}
                  </span>
                </Link>
              </Paragraph>
            </div>
          </div>
        </div>
        <Paragraph
          size={'small'}
          color={'white'}
          additionalClass={'footer__copyrights'}
        >
          &#169; {new Date().getFullYear()} Boldare. All rights reserved.
        </Paragraph>
      </footer>
    </Section>
  );
}

export default Footer;
